import React, { useState } from 'react';
import { Modal } from '@madeeasy/universal-login';
import { useUser } from '../../contexts/ssr-user-context';

export default function LoginButton() {
  const { user } = useUser();
  const isLoggedIn = Boolean(user?.id);
  const [showLogin, setShowLogin] = useState(false);

  if (isLoggedIn) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setShowLogin(true)}
        className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-customBlue text-white font-semibold text-sm shadow-sm hover:bg-[#025a99] active:scale-[0.98] transition-all duration-200"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
          <polyline points="10 17 15 12 10 7" />
          <line x1="15" y1="12" x2="3" y2="12" />
        </svg>
        <span>Login</span>
      </button>
      {showLogin ? <Modal toggleModal={() => setShowLogin(false)} text="Login" /> : null}
    </>
  );
}
